export const fileToBase64 = (file: File): Promise<string> =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onload = () => {
      const { result } = reader;
      if (typeof result === 'string') {
        resolve(result);
      } else {
        // eslint-disable-next-line prefer-promise-reject-errors
        reject('FileReader result is not a string');
      }
    };

    reader.onerror = (error) => reject(error);

    reader.readAsDataURL(file);
  });

export const isImage = (file: File): boolean => file.type.startsWith('image/');

export const getFileExtension = (filePath: string): string => {
  const fileName = filePath.split(/[\\/]/).pop(); // Obsługuje / i \ w ścieżkach
  if (!fileName || !fileName.includes('.')) return '';
  const parts = fileName.split('.');
  return parts.length > 1 ? parts.pop() ?? '' : '';
};

export const getFileNameFromPath = (filePath: string): string =>
  filePath.split(/[\\/]/).pop() ?? '';
